export default __webpack_public_path__ + "static/media/Eina02-Regular.2e682693.ttf";